export default __webpack_public_path__ + "static/media/striketip_black_text_url.a296b8d1.png";